export default __webpack_public_path__ + "static/media/phrases_white.72b6ceff.svg";